<template>

  <div class="dynamic-block">
    <keep-alive>
      <component :is="state.component"
                 v-if="data && state.blockData && !blocksLoadingExtraData.includes(data.collection)"
                 v-bind="state.additionalProps"
                 :key="data.id"
                 :data="state.blockData"
                 :reference="data"
      />
    </keep-alive>

    <AppGridBlock
        v-if="data && state.blockData && data.collection === 'grid_block'"
        v-bind="state.additionalProps"
        :key="data.id"
        :data="state.blockData"
        :reference="data"
    />

    <AppGridBlockStatic
        v-if="data && state.blockData && data.collection === 'grid_latest_block'"
        v-bind="state.additionalProps"
        :key="data.id"
        :data="state.blockData"
        :reference="data"
    />
  </div>

</template>

<script setup lang="ts">
/*
    this block wraps any block,
    to dynamically load data & define the correct component to display
*/
import {TBlockReference} from '~/types/block-types'
import {useBlockData} from '#imports'

/* TODO: investigate - these blocks load data, this prevents an issue of loading data twice */
const blocksLoadingExtraData = ['grid_block', 'grid_latest_block']

const props = defineProps<{
  data: TBlockReference,
  vacancy?: object,
}>()

const result = await useBlockData(props.data as TBlockReference);

const state = reactive({
  blockData: result.blockData,
  additionalProps: {...result.additionalProps, vacancy: props.vacancy},
  component: result.component,
})
</script>
